import { toast } from '@/utils/flaglerToast/flaglerToast';

// vuetify-sonner typing is not correct & does not specify certain option
// params as optional (like ID), and does not export the Options type, so we
// recreate it here so we can cast our options and make typescript happy
import { ToastProps } from '@/components/FlaglerToast/types';

export function toastError(message: string, description?: string) {
  toast(message, {
    cardProps: {
      color: 'error',
      class: 'flagler',
    },
    prependIcon: 'tabler-alert-triangle-filled',
    prependIconProps: {
      size: 'large',
    },
    description,
    closeButton: true,
    vertical: true,
  } as ToastProps);
}

export function toastSuccess(message: string, description?: string) {
  toast(message, {
    cardProps: {
      color: 'success',
      class: 'flagler',
    },
    cardTextProps: {
      class: 'align-start',
    },
    prependIcon: 'tabler-square-check-filled',
    prependIconProps: {
      size: 'large',
    },
    description,
    closeButton: true,
    vertical: true,
  } as ToastProps);
}

export function toastInfo(
  message: string,
  description?: string,
  action?: { label: string; onClick: () => void },
  duration?: number
) {
  toast(message, {
    duration,
    cardProps: {
      color: 'info',
      class: 'flagler',
    },
    cardTextProps: {
      class: 'align-start',
    },
    // prependIcon: 'tabler-info-square-filled',
    description,
    closeButton: true,
    action:
      action !== undefined
        ? {
            ...action,
            buttonProps: {
              variant: 'plain',
              color: 'white',
              size: 'small',
              density: 'compact',
            },
          }
        : undefined,
  } as ToastProps);
}
